import React, { ReactNode } from 'react';

import { Stack } from '@reckon-web/stack';
import { Divider } from '@reckon-web/divider';

export const Footer = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <Divider />
      <Stack gap="medium" paddingX="xlarge" paddingY="large">
        {children}
      </Stack>
    </>
  );
};
